export const PATH_SERIES_ID = {
  SPEED: 'speed',
  IGNITION: 'ignition',
} as const;

export const MEASURE_CHANNEL_TYPE = {
  FUEL: 'fuel',
  FUEL_PERCENT: 'fuel_percent',
  RPM: 'rpm',
  HUMIDITY: 'humidity',
  TEMPERATURE_C: 'temperature_C',
  TEMPERATURE_F: 'temperature_F',
} as const;
